import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import requisitionsService from "../../util/remote/ajaxRequisitions";
const RequisitionsTable = () => {
  const navigate = useNavigate();
  const [requisitions, setRequisitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchRequisitions = async () => {
    setLoading(true);
    setError(null);
    const response = await requisitionsService.fetchRecentRequisitions();
    setLoading(false);
    if (response.status === "OK") {
      setRequisitions(response.details);
    } else {
      setError(
        "Failed to load requisitions: " + (response.message || "Unknown error")
      );
    }
  };
  useEffect(() => {
    fetchRequisitions();
  }, []);
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "UGX",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };
  if (loading) {
    return (
      <div className="card modern-card mg-b-20">
        <div className="card-body text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 fw-semibold">Loading requisitions...</p>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="card modern-card mg-b-20">
        <div className="card-body text-center">
          <div className="alert alert-danger shadow-sm" role="alert">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </div>
          <button
            className="btn btn-gradient-primary mt-3 px-4"
            onClick={fetchRequisitions}
          >
            <i className="fas fa-redo me-2"></i>Retry
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="card modern-card mg-b-20 shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-gradient-primary btn-sm px-3"
            onClick={fetchRequisitions}
            title="Refresh data"
          >
            <i className="fas fa-sync-alt me-2"></i>Refresh
          </button>
        </div>
        <div className="table-responsive">
          <table className="table modern-table text-nowrap table-hover align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Department</th>
                <th>Total Estimated Cost</th>
                <th>Narration</th>
              </tr>
            </thead>
            <tbody>
              {requisitions.length > 0 ? (
                requisitions.map((req, index) => (
                  <tr key={req.id || index}>
                    <th scope="row">{index + 1}</th>
                    <td>{req.department || "N/A"}</td>
                    <td>{formatCurrency(req.est_total || 0)}</td>
                    <td>
                      <div className="naration-wrapper">
                        {req.naration || "No description"}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-5 text-muted">
                    <i className="fas fa-inbox fa-2x mb-2"></i>
                    <p>No requisitions found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* View Requisitions Button */}
        <div className="text-end mt-4">
          <button
            className="btn btn-sm btn-gradient-primary px-4"
            onClick={() => navigate("/requisitions/View")}
          >
            <i className="fas fa-eye me-2"></i>View more
          </button>
        </div>
      </div>
      {/* Modern Styles */}
      <style>
        {`
          /* Card styles */
          .modern-card {
            border: none;
            border-radius: 12px;
            background: linear-gradient(145deg, #ffffff, #f4f6f9);
            padding: 1rem;
            transition: transform 0.2s ease-in-out;
          }
          .modern-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          }
          /* Gradient button */
          .btn-gradient-primary {
            background: linear-gradient(to right, #4169E1, #4f3ad7ff, #08427cff);
            color: #fff;
            border: none;
            border-radius: 8px;
            transition: all 0.3s ease;
          }
          .btn-gradient-primary:hover {
            opacity: 0.95;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }
          /* Royal blue luxury table header */
          .modern-table thead {
            background: linear-gradient(135deg, #37d4cc, #5098c8, #043949);
            color: #fff;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          /* Table row hover effect */
          .modern-table tbody tr:hover {
            background-color: #e6f0ff;
            cursor: pointer;
          }
          /* Narration wrapper for truncation */
          .naration-wrapper {
            max-width: 320px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            line-height: 1.5;
          }
          @media (max-width: 768px) {
            .naration-wrapper {
              max-width: 200px;
            }
          }
          @media (max-width: 576px) {
            .naration-wrapper {
              max-width: 150px;
              -webkit-line-clamp: 2;
            }
          }
        `}
      </style>
    </div>
  );
};
export default RequisitionsTable;
